export const images = {
  cng: 'https://cdn.magicpatterns.com/patterns/generated-images/a2f6a9e4-f5f3-495a-a30b-1da1542b0340.jpg',
  owner: 'https://cdn.magicpatterns.com/patterns/generated-images/8303dfa7-6659-4d76-9451-6f0b595a86a4.jpg',
  driver1: 'https://cdn.magicpatterns.com/patterns/generated-images/6c5ba627-641c-412f-9668-de34434a764f.jpg',
  driver2: 'https://cdn.magicpatterns.com/patterns/generated-images/7482a468-757f-42c0-95fd-c2a3562d2d55.jpg',
  driver3: 'https://cdn.magicpatterns.com/patterns/generated-images/37d85419-8e2c-4832-8b8c-8408748f3ccd.jpg'
};
